interface SgmNotificationAction {
  callbackEndpoint: string;
  name: string;
}

export const SgmNotificationUniverses = ['sgMarkets', 'societeGenerale', 'sgef'] as const;
export type SgmNotificationUniverse = (typeof SgmNotificationUniverses)[number];

export interface SgmProducerInfo {
  code: string;
  initials: string;
  internalOnly: boolean;
  name: string;
  universe: SgmNotificationUniverse;
}

export type SgmNotificationKind = 'info' | 'action';

export interface SgmNotification {
  actions: SgmNotificationAction[];
  category?: string | null;
  createdDate: string;
  id: number;
  isClicked: boolean;
  isExpired: boolean;
  isRead: boolean;
  kind: SgmNotificationKind;
  payload: string;
  producer: SgmProducerInfo;
  pushMobileEnabled: boolean;
  url: string;
  userEmail: string;
}

export const DELAY_RETRY = 20;
export const MAX_RETRY = 10;
export const MAX_VIEW = 50;

export const EMPLOYEE_PORTAL_PRODUCER_CODE = 'bsc_employee_portal';
